import React from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { useStore } from '../../store/index';
import { useWeb3React } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { ETHMainnetConfig } from '../../config/ETHMainnetConfig';
import { Provider as MulticallProvider } from 'ethers-multicall';
import { injected } from '@/lib/web3-react';
import { eventBus } from '../../lib/event';
import { _ } from '@/lib/lodash';
import { IotexMainnetConfig } from '../../config/IotexMainnetConfig';
import { metamaskUtils } from '../../lib/metaskUtils';
import { IotexTestnetConfig } from '../../config/IotexTestnetConfig';
import { publicConfig } from '../../config/public';

export const ETHProvider = observer(({ children }) => {
  const { god, lang } = useStore();
  const { chainId, account, activate, active, library, deactivate, error, connector } = useWeb3React<Web3Provider>();

  const store = useLocalObservable(() => ({
    get defaultChain() {
      return ETHMainnetConfig;
    },
    logout() {
      deactivate();
      god.eth.connector.latestProvider.clear();
    },
    wrongNetwork() {
      toast.error(lang.t('wrong.network'), { id: 'wrong.network' });
    }
  }));

  useEffect(() => {
    console.log({ chainId });
    if (chainId) {
      if (god.currentNetwork.allowChains.includes(chainId)) {
        god.setChain(chainId);
      }
    } else {
      // god.currentNetwork.chain.setCurrentId(BSCMainnetConfig.chainId);
      // store.wrongNetwork();
    }

    god.currentNetwork.setAccount(account);
    //@ts-ignore
    god.eth.ethers = library ? library : god.eth.defaultEthers;
    god.eth.signer = library ? library.getSigner() : null;
    god.eth.multiCall = new MulticallProvider(god.eth.ethers);
    //@ts-ignore
    if (!god.eth.multiCall._multicallAddress) {
      //@ts-ignore
      god.eth.multiCall._multicallAddress = god.currentChain.info.multicallAddr;
    }

    if (account) {
      god.setShowConnecter(false);
      god.currentNetwork.loadBalance();
    }
    god.updateTicker.setValue(god.updateTicker.value + 1);
  }, [god, library, chainId, account, active, error]);

  useEffect(() => {
    if (activate && god.eth.connector.latestProvider.value) {
      if (god.eth.connector.latestProvider.value == 'inject') {
        setTimeout(() => {
          activate(injected);
        }, 300);
      }
    }
  }, [activate, god.eth.connector.latestProvider.value]);

  useEffect(() => {
    console.log('isProd', publicConfig.isProd)
    const chain = publicConfig.isProd ?  IotexMainnetConfig : IotexTestnetConfig;
    metamaskUtils.setupNetwork({
      chainId: chain.chainId,
      blockExplorerUrls: [chain.explorerURL],
      chainName: chain.name,
      nativeCurrency: {
        decimals: chain.Coin.decimals || 18,
        name: chain.Coin.symbol,
        symbol: chain.Coin.symbol
      },
      rpcUrls: [chain.rpcUrl]
    });
    eventBus.addListener('wallet.logout', store.logout);
    return () => {
      eventBus.removeListener('wallet.logout', store.logout);
    };
  }, []);
  return <></>;
});
